"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURE_FLAGS = void 0;
var FEATURE_FLAGS;
exports.FEATURE_FLAGS = FEATURE_FLAGS;

(function (FEATURE_FLAGS) {
  FEATURE_FLAGS["ADD_ONS"] = "ADD_ONS";
  FEATURE_FLAGS["ALLOW_MARIJUANA"] = "ALLOW_MARIJUANA";
  FEATURE_FLAGS["BUCKETLIST"] = "BUCKETLIST";
  FEATURE_FLAGS["CANNED_MESSAGES"] = "CANNED_MESSAGES";
  FEATURE_FLAGS["COMPANY_OUTLINE"] = "COMPANY_OUTLINE";
  FEATURE_FLAGS["CUSTOMER_SUPPORT_CARD"] = "CUSTOMER_SUPPORT_CARD";
  FEATURE_FLAGS["DEPRECATION_WARNING"] = "DEPRECATION_WARNING";
  FEATURE_FLAGS["DISABLE_GENDER_SEEKING"] = "DISABLE_GENDER_SEEKING";
  FEATURE_FLAGS["DOMESTIC_FOOTER_ITEMS"] = "DOMESTIC_FOOTER_ITEMS";
  FEATURE_FLAGS["EXCLUDE_BODY_TYPE"] = "EXCLUDE_BODY_TYPE";
  FEATURE_FLAGS["EXCLUDE_DRINK"] = "EXCLUDE_DRINK";
  FEATURE_FLAGS["EXCLUDE_EDUCATION"] = "EXCLUDE_EDUCATION";
  FEATURE_FLAGS["EXCLUDE_ETHNICITY"] = "EXCLUDE_ETHNICITY";
  FEATURE_FLAGS["EXCLUDE_EXERCISE"] = "EXCLUDE_EXERCISE";
  FEATURE_FLAGS["EXCLUDE_HEIGHT"] = "EXCLUDE_HEIGHT";
  FEATURE_FLAGS["EXCLUDE_HOMETOWN"] = "EXCLUDE_HOMETOWN";
  FEATURE_FLAGS["EXCLUDE_INTERESTS_AND_SPORTS"] = "EXCLUDE_INTERESTS_AND_SPORTS";
  FEATURE_FLAGS["EXCLUDE_LANGUAGES"] = "EXCLUDE_LANGUAGES";
  FEATURE_FLAGS["EXCLUDE_PETS"] = "EXCLUDE_PETS";
  FEATURE_FLAGS["EXCLUDE_POLITICS"] = "EXCLUDE_POLITICS";
  FEATURE_FLAGS["EXCLUDE_RELATIONSHIP"] = "EXCLUDE_RELATIONSHIP";
  FEATURE_FLAGS["EXCLUDE_RELIGION"] = "EXCLUDE_RELIGION";
  FEATURE_FLAGS["EXCLUDE_SALARY"] = "EXCLUDE_SALARY";
  FEATURE_FLAGS["EXCLUDE_SCHOOLS"] = "EXCLUDE_SCHOOLS";
  FEATURE_FLAGS["EXCLUDE_SMOKE"] = "EXCLUDE_SMOKE";
  FEATURE_FLAGS["EXCLUDE_TOPICS"] = "EXCLUDE_TOPICS";
  FEATURE_FLAGS["EXCLUDE_TRENDING_TOPICS"] = "EXCLUDE_TRENDING_TOPICS";
  FEATURE_FLAGS["EXCLUDE_WORK"] = "EXCLUDE_WORK";
  FEATURE_FLAGS["EXPRESS_MAIL"] = "EXPRESS_MAIL";
  FEATURE_FLAGS["EXTENDED_FOOTER_LINKS"] = "EXTENDED_FOOTER_LINKS";
  FEATURE_FLAGS["FACEBOOK_CONNECT"] = "FACEBOOK_CONNECT";
  FEATURE_FLAGS["FACEBOOK_LIKE"] = "FACEBOOK_LIKE";
  FEATURE_FLAGS["FACEBOOK_PHOTO_UPLOAD"] = "FACEBOOK_PHOTO_UPLOAD";
  FEATURE_FLAGS["FIRST_NAME"] = "FIRST_NAME";
  FEATURE_FLAGS["FIRST_NAME_HAS_IMAGE"] = "FIRST_NAME_HAS_IMAGE";
  FEATURE_FLAGS["GIFT_CARD"] = "GIFT_CARD";
  FEATURE_FLAGS["GIFT_SUBSCRIPTION"] = "GIFT_SUBSCRIPTION";
  FEATURE_FLAGS["GOLD_COMPED"] = "GOLD_COMPED";
  FEATURE_FLAGS["HAS_CERTIFICATE_ONLY_SEARCH"] = "HAS_CERTIFICATE_ONLY_SEARCH";
  FEATURE_FLAGS["INSTAGRAM_PHOTO_UPLOAD"] = "INSTAGRAM_PHOTO_UPLOAD";
  FEATURE_FLAGS["IS_METRIC"] = "IS_METRIC";
  FEATURE_FLAGS["IS_SEARCH_TYPE_AHEAD_ENABLED"] = "IS_SEARCH_TYPE_AHEAD_ENABLED";
  FEATURE_FLAGS["LATAM_FREE_SUPERLIKES_INTERSTITIAL"] = "LATAM_FREE_SUPERLIKES_INTERSTITIAL";
  FEATURE_FLAGS["MATCH_EVENTS"] = "MATCH_EVENTS";
  FEATURE_FLAGS["MATCH_ME"] = "MATCH_ME";
  FEATURE_FLAGS["MATCH_PHONE"] = "MATCH_PHONE";
  FEATURE_FLAGS["MATCH_STORIES"] = "MATCH_STORIES";
  FEATURE_FLAGS["MATCH_TALKS"] = "MATCH_TALKS";
  FEATURE_FLAGS["MESSAGING"] = "MESSAGING";
  FEATURE_FLAGS["MISSED_CONNECTIONS"] = "MISSED_CONNECTIONS";
  FEATURE_FLAGS["MOBILE_APP_ADS"] = "MOBILE_APP_ADS";
  FEATURE_FLAGS["MOBILE_APP_DOWNLOAD_BANNER"] = "MOBILE_APP_DOWNLOAD_BANNER";
  FEATURE_FLAGS["MOBILE_M2_ADS"] = "MOBILE_M2_ADS";
  FEATURE_FLAGS["NO_HAMBURGER_NAV"] = "NO_HAMBURGER_NAV";
  FEATURE_FLAGS["NUDGE_NONSUBS"] = "NUDGE_NONSUBS";
  FEATURE_FLAGS["ONLY_OPPOSITE_GENDERS"] = "ONLY_OPPOSITE_GENDERS";
  FEATURE_FLAGS["ONLY_SAME_GENDERS"] = "ONLY_SAME_GENDERS";
  FEATURE_FLAGS["PLATINUM_UPGRADE"] = "PLATINUM_UPGRADE";
  FEATURE_FLAGS["POSTAL_CODE"] = "POSTAL_CODE";
  FEATURE_FLAGS["PREMIUM_BADGE"] = "PREMIUM_BADGE";
  FEATURE_FLAGS["PRIVATE_MODE"] = "PRIVATE_MODE";
  FEATURE_FLAGS["PROFILE_ASSISTANCE"] = "PROFILE_ASSISTANCE";
  FEATURE_FLAGS["PROFILE_PRO"] = "PROFILE_PRO";
  FEATURE_FLAGS["PROFILE_SHARING"] = "PROFILE_SHARING";
  FEATURE_FLAGS["REACT_FAQ"] = "REACT_FAQ";
  FEATURE_FLAGS["RECAPTCHA"] = "RECAPTCHA";
  FEATURE_FLAGS["REGION_SEARCH_ONLY"] = "REGION_SEARCH_ONLY";
  FEATURE_FLAGS["REQUIRE_VERIFICATION_TO_SEND_MESSAGES"] = "REQUIRE_VERIFICATION_TO_SEND_MESSAGES";
  FEATURE_FLAGS["SAFETY_CENTER"] = "SAFETY_CENTER";
  FEATURE_FLAGS["SCHOOLS_SUPPORTED"] = "SCHOOLS_SUPPORTED";
  FEATURE_FLAGS["SHOW_CERTIFICATES"] = "SHOW_CERTIFICATES";
  FEATURE_FLAGS["SMART_FILTERS"] = "SMART_FILTERS";
  FEATURE_FLAGS["SOCIAL_LINKS"] = "SOCIAL_LINKS";
  FEATURE_FLAGS["SPECIFIED_COMMERCIAL_TRANSACTIONS_LAW"] = "SPECIFIED_COMMERCIAL_TRANSACTIONS_LAW";
  FEATURE_FLAGS["SUBSCRIPTION_BENEFITS"] = "SUBSCRIPTION_BENEFITS";
  FEATURE_FLAGS["SUPER_LIKES"] = "SUPER_LIKES";
  FEATURE_FLAGS["TOP_SPOT"] = "TOP_SPOT";
  FEATURE_FLAGS["AGE_THRESHOLD_AUTO_COMPED"] = "AGE_THRESHOLD_AUTO_COMPED";
  FEATURE_FLAGS["UNDERCOVER"] = "UNDERCOVER";
  FEATURE_FLAGS["ZERO_STATE_LIKES_UPGRADE_WALL"] = "ZERO_STATE_LIKES_UPGRADE_WALL";
})(FEATURE_FLAGS || (exports.FEATURE_FLAGS = FEATURE_FLAGS = {}));